import { css } from "@emotion/react";

export const inputStyle = css`
  max-width: 220px;
`;

export const swatchStyle = css`
  width: 18px;
  height: 18px;
  margin: 0;
  padding: 0;
  border-radius: 3px;
`;
